import React from 'react'

import { useUnit } from 'effector-react'

import { useMediaQueries } from 'hooks'

import { format as formatDate } from 'helpers/date.js'
import { format as formatMoney } from 'helpers/money'

import { type SippTransferRequest } from 'app/effector/nominees-transfers/request/sipp'

import { Typo } from 'components/_old/Typo'

import { Card } from 'components/atoms/Card'
import Flow from 'components/atoms/Flow/Flow'
import { Paper } from 'components/atoms/Paper'
import { Repel } from 'components/atoms/Repel'
import { Typography } from 'components/atoms/Typography'
import { VisuallyHidden } from 'components/atoms/VisuallyHidden'

import './ActiveTransferCard.css'

import * as model from '../../model'

type ActiveTransferCardProps = {
  request: SippTransferRequest
}

const ActiveTransferCard = ({ request }: ActiveTransferCardProps): JSX.Element | null => {
  const dispalyedProviders = useUnit(model.$displayedProviders)
  const { desktop } = useMediaQueries()
  const provider = dispalyedProviders.find((provider) => provider.id === request.provider)
  const { created, plan_number: planNumber, amount } = request

  return (
    <Paper top={24} left={24} right={24} bottom={24} mix className="ActiveTransferCard">
      <Card level={0}>
        <img alt="" src={provider?.logo ?? ''} width={48} height={48} />
        <Flow space={8}>
          <Repel gap={16}>
            {provider?.name && (
              <div className="ActiveTransferCard-Text_truncated">
                <Typography tag="h3" size={desktop ? 18 : 16} weight="semibold">
                  <Typo>{provider.name}</Typo>
                </Typography>
              </div>
            )}
            {amount && (
              <Typography tag="p" size={desktop ? 18 : 16} weight="semibold">
                <VisuallyHidden tag="span">Transfer amount: </VisuallyHidden>
                <Typo>{formatMoney(amount, true, true)}</Typo>
              </Typography>
            )}
          </Repel>

          {created && (
            <Typography tag="p" size={14} lineHeight="small" color="additional">
              <Typo>Transfer submitted date: {formatDate(created)}</Typo>
            </Typography>
          )}

          {planNumber && (
            <Typography tag="p" size={14} lineHeight="small" color="additional">
              <Typo>Reference number: {planNumber} </Typo>
            </Typography>
          )}
        </Flow>
      </Card>
    </Paper>
  )
}

export { ActiveTransferCard }
